<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索材料..."
          @on-change="searchRawMaterial"
          clearable
          icon="ios-search"
          style="width: 250px; margin-right: 30px"
        >
        </Input>
        <Select
          placeholder="禁用显示"
          v-model="isInvalid"
          label-in-value
          @on-change="choseIsInvalid"
          style="width: 25%; margin-right: 20px"
        >
          <Option
            v-for="item in isInvalidList"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <span>共{{ totalRows }}条</span>
          <Page
            :total="totalRows"
            :page-size="50"
            @on-change="loadCaclPurchase"
            show-total
            simple
          />
        </div>
        <Button type="primary" @click="openCreateMaterialDrawer()"
          >新增原材料</Button
        >
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        border
        :loading="tableLoading"
        :columns="columns"
        :data="latestPurchases"
        :height="tableHeight"
      >
      </Table>
    </div>
    <EditRawMaterialDrawer ref="EditRawMaterialDrawer" />
    <MaterialPurchaseDrawer ref="MaterialPurchaseDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EditRawMaterialDrawer from "../RawMaterialPage/EditRawMaterialDrawer.vue";
import MaterialPurchaseDrawer from "../RawMaterialPage/MaterialPurchaseDrawer.vue";
import _ from "lodash";

export default {
  name: "caclPurchase",
  components: { EditRawMaterialDrawer, MaterialPurchaseDrawer },
  data() {
    return {
      page: 0,
      tableLoading: false,
      searchText: "",
      tableHeight: 300,
      isInvalid: "false",
      isInvalidList: [
        { value: "all", label: "显示全部" },
        { value: "false", label: "隐藏禁用" },
        { value: "true", label: "查看禁用" },
      ],
      filterQuery: { limit: 50, invalid: false },
      columns: [
        {
          title: "原材料名",
          key: "row",
          width: 180,
          render: (h, params) =>
            h("span", { style: { color: "#42b983" } }, params.row.name),
        },
        {
          title: "采购",
          key: "purchase",
          align: "center",
          width: 80,
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    color: "#2D8CF0",
                    cursor: "pointer",
                    borderRadius: "4px",
                    border: "1px solid #2D8CF0",
                  },
                  on: {
                    click: () => {
                      this.$refs.MaterialPurchaseDrawer.openDrawer(params.row);
                    },
                  },
                },
                "采购"
              ),
            ]);
          },
        },
        {
          title: "用于复配",
          key: "ml",
          width: 110,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.usedForProduct ? "是" : "");
          },
        },
        {
          title: "用于合成",
          key: "product",
          width: 110,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.usedForSemi ? "是" : "");
          },
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
          minWidth: 150,
          render: (h, params) => {
            return h("span", params.row.remark);
          },
        },
        {
          title: "是否禁用",
          key: "isInvalid",
          render: (h, params) => {
            return h("span", params.row.invalid ? '是' : '否');
          },
          align: "center",
          maxWidth: 80,
          minWidth: 60,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      totalRows: (state) => state.material.totalCounts,
      factoryList: (state) => state.factory.factoryList,
      currentUser: (state) => state.auth.currentUser,
      latestPurchases: (state) => state.purchase.latestPurchases,
    }),
  },

  methods: {
    ...mapActions({
      getMaterials: "material/getMaterialsAction",
      getFactorys: "factory/getFactorysAction",
      getLatestPurchases: "purchase/getRawMaterialLatestPurchasesAction",
    }),
    openCreateMaterialDrawer() {
      this.$refs.EditRawMaterialDrawer.openDrawer("raw");
    },
    searchRawMaterial: _.debounce(function () {
      this.page = 0;
      this.loadCaclPurchase();
    }, 1000),
    async choseIsInvalid(option) {
      switch (option.value) {
        case 'all':
          delete this.filterQuery.invalid
          break;
        case 'true':
          this.filterQuery.invalid = true
          break;
        case 'false':
          this.filterQuery.invalid = false
          break;
      }
      await this.loadCaclPurchase();
    },
    async loadCaclPurchase(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        skip: this.page * 15,
      };
      if (this.searchText && this.searchText.trim() !== "") {
        this.filterQuery.searchText = this.searchText;
      } else {
        delete this.filterQuery.searchText;
      }
      this.tableLoading = true;
      await this.getLatestPurchases(this.filterQuery);
      this.tableLoading = false;
      for (let i = 0; i < this.factoryList.length; i++) {
        const factoryId = this.factoryList[i]._id;
        let factory = {};
        factory.key = `factory${i}`;
        factory.width = 100;
        factory.align = "right";
        factory.renderHeader = (h, params) => {
          return h("div", this.factoryList[i].name);
        };
        factory.render = (h, params) => {
          for (let i = 0; i < params.row.price.length; i++) {
            if (params.row.price[i].latestPrice) {
              if (params.row.price[i].factory === factoryId) {
                const latestPurchases = params.row.price[i].latestPrice;
                return h("div", latestPurchases);
              }
            }
          }
        };
        // this.columns.push(factory)
        if (this.columns.length <= this.factoryList.length + 5) {
          this.columns.splice(2+i, 0, factory);
        }
      }
    },
  },
  async created() {
    await this.getFactorys();
    await this.loadCaclPurchase();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>